export default "__VITE_ASSET__sUOUvpUD__"